import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { useLang } from "@/context/LanguageContext";

export function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const { t } = useLang();
  const isLight = theme === "light";
  const label = isLight ? t("theme.dark") : t("theme.light");
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={label}
      title={label}
      className={`inline-flex items-center justify-center w-9 h-9 border border-white/15 text-zinc-300 hover:text-white hover:border-[#E60000] transition-colors ${className}`}
    >
      {isLight ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
    </button>
  );
}
